<script>
import AmbientVideoPlayer from '@rei/ambient-video-player';
import BannerComponent from '@rei/banner-component';
import { LandingContentBlock } from '@rei/landing-content-block';
import LandingImageComponent from '@rei/landing-image-component';
import palettes from '../../mixins/palettes';

export default {
  name: 'ComplexLead',
  components: {
    AmbientVideoPlayer,
    LandingImageComponent,
    BannerComponent,
    LandingContentBlock,
  },
  mixins: [palettes],
  props: {
    media: { type: Object, required: false, default: () => null },
    content: { type: Object, required: false, default: () => {} },
    bannerComponentProps: { type: Object, required: false, default: () => {} },
    videoFocalPoint: { type: String, required: false, default: '' },
  },
  computed: {
    cssVars() {
      return {
        '--video-focal-point': this.videoFocalPoint,
        ...this.cssSurfacePaletteVars,
      };
    },
    useVideoBackground() {
      return !!this.media?.webm || !!this.media?.mp4;
    },
  },
};

</script>
<template>
  <div
    :class="'complex-lead'"
    :style="cssVars"
  >
    <banner-component
      class="lead-component"
      v-bind="bannerComponentProps"
      :style="cssSurfacePaletteVars"
    >
      <template
        v-if="media"
        #background
      >
        <ambient-video-player
          v-if="useVideoBackground"
          :src="media"
          :poster="media.poster"
          :cover="true"
          :style="cssVars"
          data-ui="lead-component-ambient-video-player"
        />
        <landing-image-component
          v-else
          v-bind="media"
          :lazy-load="false"
          fetch-priority="high"
          data-ui="lead-component-image"
        />
      </template>
      <template
        v-if="content"
        #content
      >
        <landing-content-block
          data-ui="lead-component-content"
          v-bind="content"
        />
      </template>
    </banner-component>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
@import "@rei/cdr-component-variables/dist/scss/index.scss";
.complex-lead {
  background: var(--palette-background-color);
  .banner__content-block {
    z-index: 10;
  }

  .banner__content-block {
    z-index: 0;
  }
  .ambient-video {
    z-index: 0;

    &.ambient-video--cover.ambient-video--ready {
      position: static;
    }
    &__player {
      object-position: var(--video-focal-point);
    }
    &__controls {
      z-index: 10;
    }
  }
}
</style>
